import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTBody as ClbTableTBody_ } from '@celebration/design-system/dist/lib/table-tbody';
export const ClbTableTBody = createComponent({
    tagName: ClbTableTBody_.tagName,
    elementClass: ClbTableTBody_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map